import React, {Component} from 'react';
import { connect } from 'react-redux';
import {verifyRegisterPhone} from '../../action/investmentAction.js';
import {getCapchaCode} from '../../action/loginAction.js';
import NavigatorMain from '../NavigatorMain';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';

class ForgetPassword extends Component{
  state={
    mobileNumber: '',
    CapchaCode: '',
    animating: false,
    serverCapchaCode: '',
    imageBase64: '',
    getCapchaSuccess: false,
    flag: false
  }

  componentWillMount() {
    document.title = "找回登录密码";
    let mobileNumber = sessionStorage.getItem("ForgetPassword_mobileNumber");
    if(mobileNumber) {
      this.setState({
        mobileNumber: mobileNumber
      });
    }
  }

  componentDidMount(){
    this.props.dispatch(getCapchaCode({scale: window.devicePixelRatio},(code, imageBase64)=>{this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }

  getCapchaCodeAgain = () => {
    this.props.dispatch(getCapchaCode({scale: window.devicePixelRatio},(code,imageBase64)=>{this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }

  handleVerify = () => {
    if(!this.state.mobileNumber){
      Toast.info('请输入手机号码', 2);
      return;
    }
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!this.state.CapchaCode){
      Toast.info('请输入右侧验证码', 2);
      return;
    }
    if(this.state.CapchaCode.toUpperCase()!= this.state.serverCapchaCode){
      Toast.info('验证码错误', 2);
      this.getCapchaCodeAgain();
      return;
    }
    this.setState({
      flag: true
    });
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.state.mobileNumber}, ()=>{this.verifyRegisterPhoneErr('该手机号码为未注册号码，请确认输入正确手机号码')}, (msg)=>{this.verifyRegisterPhoneErr(msg)}, (phoneNum)=>{this.verifyRegisterPhoneSuc(phoneNum)}));
  }

  verifyRegisterPhoneSuc = (phoneNum) => {
    this.setState({
      flag: false
    });
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    sessionStorage.setItem("ForgetPassword_mobileNumber", phoneNum);
    hashHistory.push({
      pathname: "/verifyDynamicCode",
      state: {
        mobileNumber: phoneNum,
        route: route,
        callback: callback
      }
    });
  }

  verifyRegisterPhoneErr = (msg) => {
    this.setState({
      flag: false
    });
    Toast.info(msg, 2);
  }

  getCapchaCodeSuccess = (code, imageBase64) => {
    this.setState({
      serverCapchaCode: code,
      imageBase64
    });
    this.setState({getCapchaSuccess: true});
  }

  getCapchaCodeError(msg){
    Toast.info(msg, 2);
    this.setState({getCapchaSuccess: false});
  }

  goBack = () => {
    hashHistory.goBack();
  }

  changeMobileNo = (event) => {
    this.setState({
      mobileNumber: event.target.value
    });
  }

  changeCatpCode = (event) => {
    this.setState({
      CapchaCode: event.target.value
    });
  }

  render(){
    return(
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>找回登录密码</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex",
            position: "relative"
          }}>
            <span style = {{
              color: '#3a3e47',
              paddingLeft: 13,
              fontSize: 14,
              width: 90
            }}>手机号</span>
            <div style = {{
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              display: "-webkit-flex",
              WebkitFlex: 1
            }}>
              <input autocomplete="off" type="text" style = {{
                WebkitFlex: 1,
                fontSize: 14,
                color: '#3a3e47'
              }} placeholder = '请输入注册手机号' value = {this.state.mobileNumber} onChange = {this.changeMobileNo}/>
              <div onClick = {()=>{this.setState({mobileNumber: ''})}}>
                <img style={{
                  marginRight: -2,
                  width: 44,
                  height: 44
                }} src={require('../../img/login_input_cancel.png')} />
              </div>
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottomColor: 'rgba(242,245,247,1)',
            borderBottomWidth: 1,
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex",
            position: "relative"
          }}>
            <span style = {{
              color: '#3a3e47',
              paddingLeft: 13,
              fontSize: 14,
              width: 90
            }}>验证码</span>
            <div style = {{
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              display: "-webkit-flex",
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 10}}>
                <input autocomplete="off" style = {{
                  width: "100%",
                  fontSize: 14,
                  color: '#3a3e47'
                }} placeholder = '请输入右侧验证码' value = {this.state.CapchaCode} onChange = {this.changeCatpCode}/>
              </div>
              <div onClick = {this.getCapchaCodeAgain} style={{paddingRight: 13}}>
              { this.state.getCapchaSuccess ? 
                <div style={{width: 63}}>
                  <img style={{
                    width: 63,
                    height: 27
                  }} src={`data:image/png;base64,${this.state.imageBase64}`} />
                </div>
                :
                <div style={{
                  WebkitFlexDirection: 'row',
                  WebkitJustifyContent: 'center',
                  WebkitAlignItems: 'center',
                  width: 63,
                  height: 27,
                  backgroundColor: '#afb0b2',
                  display: "-webkit-flex"
                }}>
                  <span style={{
                    fontSize: 10,
                    color: '#3a3e47',
                  }}>加载中...</span>
                </div>
              }
              </div>
            </div>
          </div>
          <div style = {{
             marginTop: 15,
              marginLeft: 13,
              marginRight: 13,
              borderRadius: 20
          }} onClick = {this.state.CapchaCode && this.state.mobileNumber ? this.handleVerify : null }>
            <div style = {{
              marginTop: 14,
              marginLeft: 13,
              marginRight: 13,
              padding: 10,
              backgroundColor: this.state.CapchaCode && this.state.mobileNumber ? '#fa063a' : '#afb0b2',
              borderRadius: 22,
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitJustifyContent: 'center',
              display: "-webkit-flex"
              }}>
              <span style = {{color: '#ffffff', fontSize: 15}}>下一步</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(ForgetPassword);


// WEBPACK FOOTER //
// ./src/components/login/ForgetPassword.js